import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getIdData } from "../../../lib/studentinfo";
import { getDataByPname } from "../../../lib/parameters";

import Student12TopMenu from "../studentInfo/student12topmenu";
import Student911TopMenu from "../studentInfo/student911topmenu";

import GlobalStudentProgressCheck from "../../pages/common/globalstudentprogresscheck";

import PageNotes from "../../pages/common/pagenotesnew";
import { useAuth } from "../../../usercontext";

export default function InstructorStudentProgressCheck() {
  const { slug } = useParams();
  const { profile, setProfile } = useAuth();
  const [isStudent911, setisStudent911] = useState(false);
  const [isStudent12, setisStudent12] = useState(false);

  const [ type, setType] = useState(null);

  async function GetData() {
    const info = await getIdData(slug);
    if (info[0].role === "Student911") {
      setisStudent911(true);
    } else if (info[0].role === "Student12") {
      setisStudent12(true);
    }
  }

  async function GetInstructorParameters() {
    const parameter = await getDataByPname("instructor");
    
    parameter && setType(parameter[0].id)
  }

  useEffect(() => {
    GetData();
    GetInstructorParameters()
  }, []);

  return (
    <>
      {isStudent911 && (
        <Student911TopMenu slug={slug} activeMenu={"ProgressCheck"} />
      )}
      {isStudent12 && (
        <Student12TopMenu slug={slug} activeMenu={"ProgressCheck"} />
      )}
      <PageNotes
        type={"Instructor"}
        pageName={"ProgressCheck"}
        studentId={slug}
        instructorId={profile.id}
      />
      <div className="tak-instruct-group">
        <div className="row">
          <div className="col-md-12">
            <GlobalStudentProgressCheck studentId={slug} type={226} />
          </div>
        </div>
      </div>
    </>
  );
}
